export const points = [
  {
    name: "3x Lombard Lux",
    logo: "/points/lombard.svg",
    collateralVaults: ["0x80E0d452da8eb37c8db9C8E89103DC92aD477773"],
  },
  {
    name: "3x Lombard Lux",
    logo: "/points/lombard.svg",
    collateralVaults: ["0xced95f4cF51dE12F0a0af62F1b53828491d21Ca9"],
  },
  {
    name: "3x Spice",
    logo: "/points/spice.svg",
    collateralVaults: [
      "0x11DA346d3Fdb62641BDbfebfd54b81CAA871aEf6",
      "0x33Cc3800574c4bEe6D7428e707Db82d1543d639D",
      "0x1A681ED31eA68455A73D187929973e7095c31932",
      "0x31AB3523467f9e1788EFf6df8f4DE301026EdE8f",
      "0xf168679179AA9b6E7772C8eCa4F8afB0B75ED346",
    ],
  },
  {
    name: "9x Spice",
    logo: "/points/spice.svg",
    collateralVaults: [
      "0x80E0d452da8eb37c8db9C8E89103DC92aD477773",
      "0xced95f4cF51dE12F0a0af62F1b53828491d21Ca9",
      "0xB615D3123410EE89542b027DC71e87b4Fc05EA80",
      "0x77CE4B784b494c4b089ACa5fbD7938F9c6f5F37B",
    ],
  },
] as const
